import React, { Component } from "react";
import Grid from '@mui/material/Grid';
import SpinnerModal from "@components/SpinnerModal";
import { useDialog } from 'react-st-modal';
import styles from './addsurveycycledialog.module.css';
import SupportAlert from '@components/SupportAlert';
import TextField from '@mui/material/TextField';
import SurveyService from '@services/SurveyService';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox';

class AddSurveyCycleDialog extends Component {
    state = {
        loading: false,

        surveyCycle: {
            id: null,
            name: '',
            referenceFromYear: '',
            referenceToYear: '',
            active: true,
            status: 'INPLANNING',
            description: ' ',
            comment: '',
            capturePolicyCount: 2
        },

        sectors: [],

        allSectors: [],
    }

    async componentDidMount() {
        this.setState({ loading: true });

        const sectors = await SurveyService.getAllSectors();
        sectors.forEach(item => {
            if (!this.state.allSectors.some(element => element.id === item.id)) {
                this.state.allSectors.push(item)
            }
        });

        this.setState({ loading: false });
    }

    handleChangedValue = (evt) => {
        switch (evt.target.name) {
            case 'referenceFromYear': {
                const surveyCycle = this.state.surveyCycle;
                surveyCycle.referenceFromYear = evt.target.value;
                surveyCycle.name = 'R&D Survey ' + evt.target.value + '/' + this.state.surveyCycle.referenceToYear
                this.setState({ surveyCycle: surveyCycle });
                break;

            }
            case 'referenceToYear': {
                const surveyCycle = this.state.surveyCycle;
                surveyCycle.referenceToYear = evt.target.value;
                surveyCycle.name = 'R&D Survey ' + this.state.surveyCycle.referenceFromYear + '/' + evt.target.value
                this.setState({ surveyCycle: surveyCycle });
                break;
            }
            case 'description': {
                const surveyCycle = this.state.surveyCycle;
                surveyCycle.description = evt.target.value;
                this.setState({ surveyCycle: surveyCycle });
                break;
            }
            default: {
                break;
            }
        }
    }

    getData() {

        const createSurveyCycleDTO = {
            actionBy: this.props.surveysUserId,
            surveyCycle: this.state.surveyCycle,
            sectors: this.state.sectors
        }

        return createSurveyCycleDTO;

    }

    dialogBody() {
        return <div className={styles.flex_row_container}>
            <div className={styles.featuredItem}>
                <h1>
                    <text className={styles.featuredTitleHeader}>{"Survey Cycle Details"}</text>
                </h1>
                <br />
                <p>
                    <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                        <Grid container item xs={12}>
                            <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                                <Grid container item xs={6}>
                                    <TextField
                                        disabled={false}
                                        className={styles.dialogInputs}
                                        require="required"
                                        name={'referenceFromYear'}
                                        type="text"
                                        placeholder={(new Date().getFullYear() - 1).toString()}
                                        id="outlined-basic"
                                        size="small"
                                        label={'From Year'}
                                        required
                                        value={this.state.surveyCycle.referenceFromYear}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={(evt) => this.handleChangedValue(evt)}
                                    />
                                </Grid>
                                <Grid container item xs={6} >
                                    <TextField
                                        disabled={false}
                                        className={styles.dialogInputs}
                                        require="required"
                                        name={'referenceToYear'}
                                        type="text"
                                        placeholder={new Date().getFullYear().toString()}
                                        id="outlined-basic"
                                        size="small"
                                        label={'To Year'}
                                        required
                                        value={this.state.surveyCycle.referenceToYear}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={(evt) => this.handleChangedValue(evt)}
                                    />
                                </Grid>
                            </Grid>
                            <br />
                            <br />
                            <br />
                            <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                                <Grid container item xs={12}>
                                    <TextField
                                        disabled={true}
                                        className={styles.dialogInputs}
                                        require="required"
                                        name={'survey_cycle_name'}
                                        type="text"
                                        placeholder={'R&D Survey 2024/2025'}
                                        id="outlined-basic"
                                        size="small"
                                        label={'Survey Cycle Name'}
                                        required
                                        value={this.state.surveyCycle.name}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <br />
                            <br />
                            <br />
                            <Grid container spacing={3} direction="row" justify-content="space-between" wrap="nowrap">
                                <Grid container item xs={12} >
                                    <TextField
                                        disabled={false}
                                        name={'description'}
                                        className={styles.dialogInputs}
                                        id="outlined-multiline-static"
                                        label="Description"
                                        multiline
                                        rows={4}
                                        placeholder={'Ipsum lorem ..'}
                                        required
                                        value={this.state.surveyCycle.description}
                                        onChange={(evt) => this.handleChangedValue(evt)}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </p>
                <p>
                    <h1>
                        <text className={styles.featuredTitleHeader}>{"Select Sectors"}</text>
                    </h1>
                    {/* Replace the commented section around line 203 with this */}

                    <Grid container spacing={3} direction="row" justify="space-between" wrap="nowrap">
                        <Grid container item xs={12}>
                            <FormControl component="fieldset" className={styles.formControl}>
                                <Grid container spacing={1}>
                                    {this.state.allSectors.map((sector, index) => (
                                        <Grid item xs={6} key={sector.id}>
                                            <FormControlLabel
                                                key={sector.id}
                                                className={styles.sectorLabel}
                                                control={
                                                    <Checkbox
                                                        checked={this.state.sectors.some(s => s.id === sector.id)}
                                                        onChange={(event) => {
                                                            let sectors = this.state.sectors;
                                                            if (event.target.checked) {
                                                                // Add sector by copying it exactly as is from allSectors
                                                                sectors.push(this.state.allSectors.find(s => s.id === sector.id));
                                                            } else {
                                                                // Remove sector by filtering it out
                                                                sectors = sectors.filter(s => s.id !== sector.id);
                                                            }
                                                            this.setState({ sectors });
                                                        }}
                                                        name={`sector-${sector.id}`}
                                                        color="primary"
                                                        size="small"
                                                    />
                                                }
                                                label={sector.name}
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </FormControl>
                        </Grid>
                    </Grid>
                </p>
            </div>
        </div>
    }

    render() {
        if (this.state.loading === true) {
            return <SpinnerModal settings={true} label={'Dialog loading ...'} />
        } else {
            return <DialogWrapper
                {...this.props}
                onClick={(evt) => this.props.nextButton.onClick(evt, this.getData())}
                validDetails={(this.state.surveyCycle.referenceFromYear !== undefined && this.state.surveyCycle.referenceFromYear !== null && this.state.surveyCycle.referenceFromYear !== '')
                    && (this.state.surveyCycle.referenceToYear !== undefined && this.state.surveyCycle.referenceToYear !== null && this.state.surveyCycle.referenceToYear !== '')
                    && (this.state.surveyCycle.name !== undefined && this.state.surveyCycle.name !== null && this.state.surveyCycle.name !== '')
                    && (this.state.sectors.length > 0)}
                content={
                    <React.Fragment>
                        {this.dialogBody()}
                    </React.Fragment>
                }
            />
        }
    }

}
export default AddSurveyCycleDialog;

function DialogWrapper(props) {
    const dialog = useDialog();

    return (
        <div>
            <br />
            <div>
                {props.content}
            </div>
            <div>
                {props.backButton !== undefined && props.backButton !== null
                    ? <button type="button" className="btnBack"
                        onClick={() => {
                            dialog.close(false);
                        }}
                    >
                        {props.backButton.text}
                    </button>
                    : <div />
                }
                {props.nextButton !== undefined && props.nextButton !== null
                    ? <button type="button" className="btnNext"
                        onClick={(evt) => {
                            if (!props.validDetails) {
                                SupportAlert.displayAlert('Required', 'Please review supplied information!');
                            } else {
                                props.onClick(evt);
                                dialog.close(true);
                            }
                        }}
                    >
                        {props.nextButton.text}
                    </button>
                    : <div />
                }
            </div>
        </div>
    );
}

